<template>
  <transition name="fade" mode="in-out">
    <b-row align-v="end" align-h="around" v-if="!isDone" class="mb-3" :key="1">
      <b-col cols="12" lg="8">
        <b-card class="shadow-lg p-0 p-sm-2">
          <h2 class="text-center mb-4">Récapitulatif</h2>
          <div v-if="office && !appointment.distancial">
            <h5>{{ office.name }}</h5>
            <p>
              <span v-if="office.address">Adresse : <b>{{ office.address }}</b></span><br />
              <span v-if="office.phone">Numéro de téléphone : <b>{{ office.phone }}</b></span>
            </p>
          </div>
          <div v-if="appointment.distancial">
            <p>Type de rendez-vous : <b>En visio</b></p>
          </div>
          <p>
            Date :
            <b>{{ displayDate(appointment.appointment.start) }}</b>

            <br />
            Rendez-vous avec : {{ consultant.email }}
          </p>

          <div class="d-block text-danger mb-2" v-if="isDone === null">
            Une erreur est survenue, veuillez réessayer ultérieurement
          </div>
          <b-button
            v-on:click="validate"
            variant="primary"
            round
            class="mx-auto"
            :disabled="loading && isDone !== null"
            >Confirmer ce rendez-vous
            <b-spinner
              small
              type="grow"
              class="ml-2"
              v-if="loading === true && isDone !== null"
          /></b-button>
        </b-card>
      </b-col>

      <b-col cols="12" lg="4" class="mt-5">
        <img src="../assets/third.svg" class="img-fluid d-block mx-auto" />
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="around" v-else :key="2">
      <b-col cols="12" md="10" lg="8">
        <b-card class="shadow-lg py-4 px-0 px-sm-4 px-md-5 text-center">
          <h2 class="mb-4">Votre rendez-vous est bien confirmé</h2>
          <h6>Vous allez recevoir un mail de confirmation.</h6>
          <span v-if="$root.slug === 'demo'" class="text-muted font-italic">(<b>Version de démonstration</b> : aucun mail envoyé)</span>
        </b-card>
      </b-col>
    </b-row>
  </transition>
</template>

<script>
import moment from "moment";

export default {
  name: "Summary",

  props: {
    office: Object,
    appointment: Object,
    isDone: Boolean,
  },

  data() {
    return {
      loading: false,
      consultant: {
        firstName: null,
        lastName: null,
        email: null,
      },
    };
  },

  mounted() {
    this.consultant.email = this.appointment.appointment.consultant;
    const name = this.consultant.email.split("@")[0]?.split(".");
    this.consultant.firstName = name[0] ?? null;
    this.consultant.lastName = name[1] ?? null;
  },

  methods: {
    validate() {
      this.loading = true;
      this.$emit("done");
    },
    displayDate(val) {
      return moment(val).locale("fr").format("dddd Do MMMM YYYY à H[h]mm");
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  display: block;
  min-width: 60%;
  margin-top: 1.5rem;
  padding: 0.5rem 1rem;
}
</style>
